import DOMPurify from 'dompurify'

// Allow-list covers what the server side markdown pipeline can produce
// (OIE.Application/Common/MarkdownService.cs -> Markdig advanced extensions,
// then Ganss.Xss). Anything outside it is stripped.
const CHAT_CONFIG = {
  ALLOWED_TAGS: [
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'p', 'br', 'hr', 'blockquote',
    'strong', 'em', 'del', 'code', 'pre',
    'ul', 'ol', 'li',
    'table', 'thead', 'tbody', 'tfoot', 'tr', 'th', 'td',
    'a', 'img', 'span', 'div'
  ],
  ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'colspan', 'rowspan'],
  // Blocks javascript:, data: and any other scheme on href/src
  ALLOWED_URI_REGEXP: /^https?:\/\//i,
  FORBID_TAGS: ['style', 'script', 'iframe', 'object', 'embed', 'form'],
  // No class/style/id, so chat content cannot restyle or shadow the page
  FORBID_ATTR: ['style', 'class', 'id'],
  KEEP_CONTENT: true,
  RETURN_TRUSTED_TYPE: false
}

const HTTP_URL = /^https?:\/\//i

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  // DOMPurify allows data: URIs on img and media tags regardless of
  // ALLOWED_URI_REGEXP, so enforce the http(s) only rule ourselves.
  ;['href', 'src'].forEach((attr) => {
    if (node.hasAttribute(attr) && !HTTP_URL.test(node.getAttribute(attr))) {
      node.removeAttribute(attr)
    }
  })

  // Links coming from chat content are untrusted, so open them safely.
  if (node.tagName === 'A' && node.hasAttribute('href')) {
    node.setAttribute('target', '_blank')
    node.setAttribute('rel', 'noopener noreferrer')
  }
})

/**
 * Sanitize HTML that is about to be rendered with v-html in the chat widget.
 * Safe to call on values read back from browser storage.
 */
export function sanitizeChatHtml(html) {
  if (typeof html !== 'string' || html === '') {
    return ''
  }
  return DOMPurify.sanitize(html, CHAT_CONFIG)
}

export default sanitizeChatHtml
